const getLabelClass = (product) => {
  if (product.isOutOfStock()) return 'label--outOfStock';
  if (product.isOnSale()) return 'label--notice';
  return null;
};

export default getLabelClass;
